import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=973730b2&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973730b2')) {
      api.createRecord('973730b2', component.options)
    } else {
      api.reload('973730b2', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=973730b2&", function () {
      api.rerender('973730b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/pagination/src/pagination.vue"
export default component.exports